import React from 'react';
import { format } from 'date-fns';
import type { ChatMessage } from '../../../types/chat';
import type { Consultant } from '../../../types/consultant';

interface ConsultantMessageProps {
  message: ChatMessage;
  consultant: Consultant;
}

export const ConsultantMessage: React.FC<ConsultantMessageProps> = ({
  message,
  consultant
}) => {
  const isConsultant = message.sender === 'consultant';

  return (
    <div className={`flex ${isConsultant ? 'justify-start' : 'justify-end'}`}>
      <div className={`flex max-w-[80%] ${isConsultant ? 'flex-row' : 'flex-row-reverse'} items-start space-x-2`}>
        {isConsultant && consultant.imageUrl && (
          <img
            src={consultant.imageUrl}
            alt={consultant.name}
            className="w-8 h-8 rounded-full object-cover"
          />
        )}
        {isConsultant && !consultant.imageUrl && (
          <div className="w-8 h-8 rounded-full bg-purple-500/30 flex items-center justify-center text-xs text-purple-200">
            {consultant.name.charAt(0).toUpperCase()}
          </div>
        )}
        
        <div className={`p-3 rounded-lg ${
          isConsultant
            ? 'bg-white/10 text-purple-200'
            : 'bg-purple-500 text-white'
        }`}>
          <p className="text-sm">{message.content}</p>
          <p className="text-xs opacity-70 mt-1">
            {format(message.timestamp, 'HH:mm')}
          </p>
        </div>

        {!isConsultant && (
          <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center">
            <span className="text-sm text-white">
              {message.sender === 'user' ? 'Você' : consultant.name[0]}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};